import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import "./index.css";
// import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import ErrorPage from "./error-page";
import Routes from "./routes";
import store from './redux/store'
import { Provider } from 'react-redux'

import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { ThemeProvider } from './feature/theme/ThemeProvider';
import ThemeControl from './feature/theme/ThemeControl';
import './feature/theme/theme.css';

let persistor = persistStore(store);

const { routes } = Routes();

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <ThemeControl />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Toaster toastOptions={{ style: { background: 'var(--surface-raised)', color: 'var(--ink)', border: '1px solid var(--line)' }, success: { iconTheme: { primary: 'var(--success)', secondary: 'var(--surface)' } }, error: { iconTheme: { primary: 'var(--danger)', secondary: 'var(--surface)' } } }} />
        <RouterProvider router={router} />
        <footer className="site-footer text-muted">
          <small>
            &copy; fxurl.co
          </small>
        </footer>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
